// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCiZkfvZ-FdAQu5f9r_khMprf0mBfzedhU",
  authDomain: "alumni-topup.firebaseapp.com",
  projectId: "alumni-topup",
  storageBucket: "alumni-topup.appspot.com",
  messagingSenderId: "239919268247",
  appId: "1:239919268247:web:4a74a00d9889ae409d84d2",
  measurementId: "G-C8YXK7RSM7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { analytics };